export enum LiveConsultEvents {
  disconnected = "disconnected",
  participantConnected = "participantConnected",
  participantDisconnected = "participantDisconnected",
  trackSubscribed = "trackSubscribed",
  trackUnsubscribed = "trackUnsubscribed",
}
